import { Injectable } from '@angular/core';
import { RaintreeResponse } from '../interfaces/raintree-response';
import { ApiService } from '../../common/api.service';
import { Observable } from 'rxjs';
import { ROUTES } from '../../server-route';
import {
  DPNFAddRequest,
  DPNFListResponse,
  DPNFStatusResponse,
} from '../interfaces/dpnf.interface';
@Injectable({
  providedIn: 'root',
})
export class DPNFTransmissionService extends ApiService {
  public fetchMyDPNFList(reqData: any): Observable<DPNFListResponse> {
    return this.get<DPNFListResponse>(ROUTES.MY_DPNF_LIST, {
      params: reqData,
    });
  }
  public fetchOthersDPNFList(reqData: any): Observable<DPNFListResponse> {
    return this.get<DPNFListResponse>(ROUTES.OTHERS_DPNF_LIST, {
      params: reqData,
    });
  }
  public getNFStatus(reqData: any): Observable<DPNFStatusResponse> {
    return this.get<DPNFStatusResponse>(ROUTES.DPNF_STATUS, {});
  }
  public rejectDPNF(reqData: any): Observable<any> {
    return this.patch<any>(ROUTES.DELETE_DPNF, {
      body: reqData,
    });
  }
  public removeData(reqData: any): Observable<any> {
    return this.delete<any>(ROUTES.REMOVE_DPNF, {
      body: reqData,
    });
  }
  public addDPNF(reqData: DPNFAddRequest): Observable<any> {
    return this.post<any>(ROUTES.ADD_DPNF, {
      body: reqData,
    });
  }
  public foundByOtherFw(reqData: any): Observable<any> {
    return this.get<any>(ROUTES.FOUND_BY_USER, {
      params: reqData,
    });
  }
  public editDPNF(reqData: DPNFAddRequest): Observable<any> {
    return this.put<any>(ROUTES.ADD_DPNF, {
      body: reqData,
    });
  }
  public fetchUserNames
    (reqBody: any): Observable<any> {
    return this.get<any>(ROUTES.FW_NAMES_DPNF, {
      params: reqBody,
    });
  }
}
